export default theme => ({
  root: {
    maxWidth: 1100,
    minWidth: 600,
    '& .MuiTypography-h6': {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(3)
    }
  },
  form: {
    marginTop: theme.spacing(3)
  },
  downloadButton: {
    marginTop: theme.spacing(2) + ' !important'
  },
  idpMetadataTextarea: {
    resize: 'vertical'
  },
  actions: {
    marginTop: theme.spacing(5),
    '& .MuiButton-root': {
      marginRight: theme.spacing(1)
    }
  },
  testResultDialog: {
    '& .MuiTypography-subtitle1': {
      marginTop: theme.spacing(1),
      fontWeight: 500
    },
    '& .MuiTableCell-root': {
      verticalAlign: 'top'
    },
    '& .MuiTableRow-root:first-child': {
      borderTop: '1px solid',
      borderTopColor: theme.palette.divider
    },
    '& .MuiTableCell-root:first-child': {
      width: '150px',
      fontWeight: 500,
      paddingLeft: theme.spacing(1)
    },
    '& .MuiTableCell-root:last-child': {
      paddingRight: theme.spacing(1)
    }
  },
  testAuthentication: {
    marginTop: 0,
    marginBottom: theme.spacing(4),
    '& .MuiAlert-root': {
      marginTop: theme.spacing(2)
    },
    '& .MuiCircularProgress-root': {
      marginTop: theme.spacing(3)
    }
  },
  errorMessage: {
    marginTop: '12px !important'
  },
  warning: {
    marginTop: theme.spacing(3)
  }
});
